import axios from 'axios';
import appConfig from '../config/config';

// Use shared config with hostname-aware fallback
const API_BASE_URL = appConfig.API_BASE_URL;

export interface WordPressPost {
    id: number;
    date: string;
    slug: string;
    title: {
        rendered: string;
    };
    content: {
        rendered: string;
        protected: boolean;
    };
    excerpt: {
        rendered: string;
        protected: boolean;
    };
    author: number;
    featured_media: number;
    _embedded?: {
        author?: Array<{
            id: number;
            name: string;
            avatar_urls?: {
                [key: string]: string;
            };
        }>;
        'wp:featuredmedia'?: Array<{
            id: number;
            source_url: string;
            alt_text: string;
        }>;
        'wp:term'?: Array<Array<{
            id: number;
            name: string;
            slug: string;
            taxonomy: string;
        }>>;
    };
}

export const postsService = {
    /**
     * Fetch posts with optional params
     * @param params - { per_page, page, search, orderby, etc }
     */
    getPosts: async (params: any = {}) => {
        try {
            // Always embed author and featured media
            const response = await axios.get<WordPressPost[]>(`${API_BASE_URL}/wp/v2/posts?_embed`, {
                params,
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching posts:', error);
            throw error;
        }
    },

    /**
     * Fetch a single post by ID
     * @param id - Post ID
     */
    getPost: async (id: number | string) => {
        try {
            const response = await axios.get<WordPressPost>(`${API_BASE_URL}/wp/v2/posts/${id}?_embed`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching post ${id}:`, error);
            throw error;
        }
    },

    /**
     * Utility to get a safe media URL
     * Sometimes WP returns internal IPs; this can help if we need to proxy, 
     * but for now we trust the source_url if accessible.
     */
    getMediaBaseUrl: (mediaObj: any) => {
        if (mediaObj && mediaObj.source_url) {
            return mediaObj.source_url;
        }
        // Fallback placeholder
        return 'https://i.ibb.co/Gp7c0HB/placeholder.jpg';
    },

    /**
     * Helper to transform WP date to readable string
     */
    formatDate: (dateString: string) => {
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        return new Date(dateString).toLocaleDateString('en-US', options);
    }
};
